export default {
  meta: {
    title: '创建拓店任务',
    url: '/standardstore/taskStandardAndClusterCreate', // 埋点字段，上报归属的模块
    urlName: '加盟直营模板' // 埋点字段，上报归属的模块
  }
};
